import React from 'react';

const CONTRACT_ADDRESS = '0x7071d339caB8B774677Dc383Dd4e750D16697057';

function TransactionHistory() {
  return (
    <div className="transaction-history">
      <h2>Ιστορικό Συναλλαγών</h2>
      <p>
        Δες το ιστορικό συναλλαγών του συμβολαίου στο{' '}
        <a
          href={`https://blockexplorer.dimikog.org/address/${CONTRACT_ADDRESS}/contracts`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Besu Explorer
        </a>.
      </p>
    </div>
  );
}

export default TransactionHistory;
